<template>
  <div name="demo-searchbox-rules">
    <hrms-search-box	 :receivedStore="receivedStore"
            			 :nowLang="nowLang"
            			 :searchBoxAlias="searchBoxAlias" />
  </div>
</template>

<script>
export default {
  name: 'demo-searchbox-rules',
  data () {
    return {
      nowLang: 'en',
      searchBoxAlias: 'demo-searchbox-rules'
    }
  },
  methods: {
    receivedStore (params) {
      console.log(params)
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoSearchboxRules.vue?0c067455